// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"fO","useThisShipOptionButtonContainer":"gO","checkoutPrimaryButton":"hO","shipOptionItem":"iO","legend":"jO","primaryHeading":"kO"};